import { render } from "./TipoDocumento.vue?vue&type=template&id=462e3c86"
import script from "./TipoDocumento.vue?vue&type=script&lang=js"
export * from "./TipoDocumento.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__